<template>
    <v-container style="padding: 16px;">
        <v-row class="ticket-notes-container">
            <v-col :class="$vuetify.breakpoint.xs ? 'mobile-view-add-note' : '' ">
                <addNote @load-ticket-details="loadTicketDetails" />
            </v-col>
            <v-col
                v-if="$vuetify.breakpoint.xs"
                class="mobile-view-selectall"
            >
                <v-checkbox
                    v-model="selectAll"
                    @change="selectAllItems"
                />Select All
            </v-col>
            <v-col>
                <deleteNote
                    :rowids="selected"
                    @load-ticket-details="loadTicketDetails"
                />
            </v-col>
        </v-row>
        <v-row
            v-if="!$vuetify.breakpoint.xs"
            class="m-0"
        >
            <v-col>
                <v-data-table
                    id="main_notes_table"
                    ref="main_notes_table"
                    v-model="selected"
                    fixed-header
                    show-select
                    :headers="headers"
                    :items="getTicketNotes"
                    item-key="rowid"
                    hide-default-footer                          
                >
                    <template v-slot:item.edit="{item}">
                        <addNote 
                            :rowid="item.rowid" 
                            :ticketnote="item.ticket_note"
                            @load-ticket-details="loadTicketDetails"
                        />
                    </template>
                    <template v-slot:item.delete="{item}">
                        <deleteNote 
                            :rowid="item.rowid" 
                            @load-ticket-details="loadTicketDetails"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <div
            v-if="$vuetify.breakpoint.xs"
            id="ticket-notes-cards"
        >
            <v-card
                v-for="item in getTicketNotes"
                :key="item.rowid"
                flat
                tile
            >
                <v-toolbar
                    flat
                    class="ticket-card-header px-3"
                >
                    <div class="checkbox-container">
                        <v-checkbox
                            v-model="selected"
                            :value="item.rowid"
                            @change="handelSelectItem"
                        />
                    </div>
                    <v-spacer />
                    <addNote 
                        :rowid="item.rowid" 
                        :ticketnote="item.ticket_note"
                        @load-ticket-details="loadTicketDetails"
                    />
                    <deleteNote 
                        :rowid="item.rowid" 
                        @load-ticket-details="loadTicketDetails"
                    />
                </v-toolbar>
                <table class="px-3 py-4">
                    <tr>
                        <td>Date Created:</td>
                        <td>{{ item.created }}</td>
                    </tr>
                    <tr>
                        <td>Account:</td>
                        <td>{{ item.created_by }}</td>
                    </tr>
                    <tr>
                        <td>Notes:</td>
                        <td style="word-break: break-all;">
                            {{ item.ticket_note }}
                        </td>
                    </tr>
                </table>
            </v-card>
        </div>
    </v-container>
</template>

<script>
import moment from 'moment';
import addNote from './addNote.vue';
import deleteNote from './deleteNote.vue';

export default {
    name: 'Notes',
    components: {
        addNote,
        deleteNote
    },
    data: () => ({
        selectAll: false,
        selected: [],
        headers: [
            {
                text: 'Date Created',
                value: 'created',
                align: 'left',
                width: '200px',
                sortable: false,
            },
            {
                text: 'Account',
                value: 'created_by',
                align: 'left',
                width: '150px',
                sortable: false,
            },
            {
                text: 'Notes',
                value: 'ticket_note',
                align: 'left',
                sortable: false,
            },
            {
                text: 'Edit',
                value: 'edit',
                align: 'center',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Delete',
                value: 'delete',
                align: 'center',
                width: '80px',
                sortable: false,
            },
        ],
    }),
    computed: {
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        },
        getTicketNotes() {
            if(this.getTicketDetails && this.getTicketDetails?.Ticket_Notes) {
                return this.getTicketDetails.Ticket_Notes.map((item) => {
                    item.created = moment(item.created).format(' DD MMM YYYY, hh:mm A');
                    return item;
                }).sort((a, b) => moment(b.created).unix() - moment(a.created).unix());
            } else {
                return [];
            }
        }
    },
    methods: {
        loadTicketDetails() {
            this.$emit('load-ticket-details');
            this.selected = [];
            this.selectAll = false;
        },
        handelSelectItem() {
            if(this.selected.length === this.getTicketNotes.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },
        selectAllItems() {
            if(this.selectAll) {
                this.selected = this.getTicketNotes.map(item => item.rowid);
            } else {
                this.selected = [];
            }
        }
    }
};
</script>

<style>
    #main_notes_table.v-data-table {
        border: 1px solid #ccc;
        width: 100%;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        overflow: hidden;
    }
    #main_notes_table.v-data-table__wrapper {
        border-radius: 4px;
    }
    #main_notes_table .v-data-table-header th{
        background: #F5F7FA !important;
    }
    #main_notes_table > .v-data-table__wrapper > table > tbody > tr > td:nth-child(4) {
        word-break: break-all;
    }
    .ticket-notes-container {
        display: flex;
        justify-content: space-between !important;
    }
    .ticket-notes-container .action-btn .v-btn__content {
        color: #122448 !important;
    }

    .mobile-view-add-note {
        position: fixed;
        bottom: 0;
        z-index: 99;
        background: white;
        border-top: 1px solid #d4d0d0;
        padding: 10px;
        left: 0;
        right: 0;
        box-shadow: 0px 0px 6px 1px #d4d0d0;
    }
    .mobile-view-add-note button {
        width: 98%;
    }
    .mobile-view-selectall {
        display: flex;
        align-items: center;
        margin: 0;
        padding: 0px 25px;
    }

    #ticket-notes-cards .v-card {
        padding-bottom: 16px;
        margin: 16px 0px;
    }
    #ticket-notes-cards .ticket-card-header {
        background-color: #F5F7FA;
    }
    #ticket-notes-cards .ticket-card-ticket-revision a {
        text-decoration: none;
        color: #1976D2;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }
    #ticket-notes-cards .ticket-card-info {
        border-radius: 4px;
        border: 1px solid #E4E7ED;
        height: 28px;
        display: inline-block;
        min-width: 40px;
        margin-top: 16px;
        margin-bottom: 16px;
        margin-right: 8px;
        padding: 4px 8px;
        color: #35383F;
        font-size: 12px;
    }
    #ticket-notes-cards table {
        font-size: 12px;
        width: 100%;
    }
    #ticket-notes-cards table tr td:first-child {
        width: 82px;
        vertical-align: top;
    }
    #ticket-notes-cards table tr td:nth-child(2) {
        font-weight: 500;
        overflow: hidden;
        word-break: break-all;
        display: inline-block;
        max-width: 335px;
    }
    #ticket-notes-cards .status-open-chip {
        margin-right: 10px;
    }
    .checkbox-container .v-input--selection-controls {
        margin-top: 16px !important;
        padding-top: 4px !important;
    }
</style>